<script>

export default {
  name: 'IntellectualPropertyPolicy'
}
</script>

<template lang="pug" src="./IntellectualPropertyPolicy.pug"></template>
